/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Ref_N1Inputs */

const en_to_yaml_ref_n1 = /** @type {(inputs: To_Yaml_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quoted, so a YAML 1.1 reader cannot turn it into false. This is the Norway problem defence.`)
};

const ko_to_yaml_ref_n1 = /** @type {(inputs: To_Yaml_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인용되므로 YAML 1.1 리더가 false로 바꿀 수 없습니다. 노르웨이 문제 방어입니다.`)
};

const ja_to_yaml_ref_n1 = /** @type {(inputs: To_Yaml_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`引用されるので YAML 1.1 のリーダが false にできません。ノルウェー問題への備えです。`)
};

/**
* | output |
* | --- |
* | "Quoted, so a YAML 1.1 reader cannot turn it into false. This is the Norway problem defence." |
*
* @param {To_Yaml_Ref_N1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_ref_n1 = /** @type {((inputs?: To_Yaml_Ref_N1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Ref_N1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_ref_n1(inputs)
	if (locale === "ko") return ko_to_yaml_ref_n1(inputs)
	return ja_to_yaml_ref_n1(inputs)
});